import { SessionHelper } from "app/helpers/sessionHelper";
import { Redirect, Route } from "react-router-dom";
// Use HOC to define a shared layout for the desktop screens
// renders either requested screen component or redirects to "/"
const MobileRoute = ({ component: Component, ...rest }: any) => (
  <Route
    {...rest}
    render={props =>
      SessionHelper.isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

export default MobileRoute;
